import globals from 'src/app/utils/globals';

export const isHotJarEnabled = () =>
  globals.window.hj &&
  globals.window.hjBootstrapCalled &&
  globals.window?.SEEK_TEST !== true;

export const hotJarTrigger = (eventName: string) => {
  if (isHotJarEnabled()) {
    globals.window.hj?.('event', eventName);
  }
};

export const hotJarIdentify = (userId: string | null, attribute: object) => {
  if (isHotJarEnabled()) {
    globals.window.hj?.('identify', userId, attribute);
  }
};
